export type ISelectAllParentNode = (node: any) => void;

export function selectAllParentNode(node: any): void {
  if (node.getParent() !== null && node.selected) {
    node.getParent().setSelected(true);
  }
}
